export const adminRequirementTooltips = {
  active: 'Pokaż w audytach.',
  publish:
    'Zmiany zostaną uwzględnione w wykonanych audytach – zmiana widoczna. Zmienione wymagania zostaną oznaczone jako nieaktualne.',
  update:
    'Zmiany zostaną uwzględnione w wykonanych audytach – zmiana niewidoczna.',
  save: 'Zmiany nie zostaną uwzględnione w wykonanych audytach – zmiana widoczna tylko w nowych audytach.',
}
